import { Radio } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import SaveAndCancelButtons from '../../Community/UI/SaveAndCancelButtons/SaveAndCancelButtons';
import { getBrowseFiltersByType } from '../../Community/util';
import { LoadingSpinnerSize } from '../../UI/LoadingSpinner';
import LoadingSpinnerInContainer from '../../UI/LoadingSpinnerInContainer';
import { useSavedFilter } from '../containers/SavedFilterDataStore';
import { useSavedFilters } from '../containers/SavedFiltersDataStore';
import DrcAvailabilityTypes from '../DrcAvailabilityTypes';
import BrowseLaneType from './BrowseLaneType';

AddEditDrcAvailabilityFilter.propTypes = {
	browseRefinements: PropTypes.array,
	viewId: PropTypes.number,
	leaveEditMode: PropTypes.func,
};

export default function AddEditDrcAvailabilityFilter({
	browseRefinements,
	viewId,
	leaveEditMode,
}) {
	const [
		selectedDrcAvailabilityType,
		setSelectedDrcAvailabilityType,
	] = React.useState(DrcAvailabilityTypes['notSet'].key);
	const [isLoading, setIsLoading] = React.useState(true);

	const savedFiltersDataStore = useSavedFilters();
	const savedFilterDataStore = useSavedFilter();

	React.useEffect(() => {
		getSavedDrcAvailabilityType();
	}, []);

	const onDrcAvailabilityTypeChange = e => {
		setSelectedDrcAvailabilityType(e.target.value);
	};

	const drcAvailabilityFilter =
		browseRefinements &&
		browseRefinements.find(
			br => br.browseLaneType === BrowseLaneType.DrcAvailability.key,
		);

	const saveFilters = () => {
		var { savedFilters } = savedFiltersDataStore.state;
		var thisSavedFilter = savedFilters.filter(sf => sf.id == viewId)[0];
		if (
			selectedDrcAvailabilityType === DrcAvailabilityTypes['notSet'].key
		) {
			thisSavedFilter.browseRefinements = thisSavedFilter.browseRefinements.filter(
				tsf =>
					tsf.browseLaneType !== BrowseLaneType.DrcAvailability.key,
			);
		} else {
			if (drcAvailabilityFilter) {
				var thisRefinement = thisSavedFilter.browseRefinements.filter(
					tsf =>
						tsf.browseLaneType ===
						BrowseLaneType.DrcAvailability.key,
				)[0];
				thisRefinement.code = selectedDrcAvailabilityType;
			} else {
				var newRefinement = {
					viewId: viewId,
					browseLaneType: BrowseLaneType.DrcAvailability.key,
					code: selectedDrcAvailabilityType,
				};
				thisSavedFilter.browseRefinements.push(newRefinement);
			}
		}

		thisSavedFilter.filtersByType = getBrowseFiltersByType(thisSavedFilter);
		savedFilterDataStore.updateFilters(thisSavedFilter);
		leaveEditMode();
	};

	const getSavedDrcAvailabilityType = () => {
		if (!drcAvailabilityFilter) {
			setSelectedDrcAvailabilityType(DrcAvailabilityTypes['notSet'].key);
		} else {
			setSelectedDrcAvailabilityType(
				DrcAvailabilityTypes[drcAvailabilityFilter.code].key,
			);
		}
		setIsLoading(false);
	};

	return !isLoading ? (
		<div className="add-edit-category-filters">
			<Radio.Group size="small" value={selectedDrcAvailabilityType}>
				{Object.keys(DrcAvailabilityTypes).map(drcAvailabilityType => {
					return (
						<Radio.Button
							value={
								DrcAvailabilityTypes[drcAvailabilityType].key
							}
							key={`drc-availability-option-${DrcAvailabilityTypes[drcAvailabilityType].key}`}
							onChange={onDrcAvailabilityTypeChange}>
							{DrcAvailabilityTypes[drcAvailabilityType].label}
						</Radio.Button>
					);
				})}
			</Radio.Group>
			<SaveAndCancelButtons
				onSave={saveFilters}
				onCancel={leaveEditMode}
			/>
		</div>
	) : (
		<LoadingSpinnerInContainer size={LoadingSpinnerSize.small} />
	);
}
